import React, { useState, useRef } from 'react';
import { useChat } from '@livekit/components-react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

const ChatMessageLine = () => {
  const { send, isSending } = useChat();
  const [input, setInput] = useState('');
  const [emojiPanelVisible, setEmojiPanelVisible] = useState(false);
  const inputRef = useRef(null);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Аноним';


  const sendMessage = async () => {
    if (!input.trim()) return;

    try {
      await send(
          JSON.stringify({
            text: input.trim(),
            sender: fullName, // ← имя, которое ты хочешь отобразить
          })
      );
      setInput('');
    } catch (err) {
      console.error('Ошибка при отправке сообщения:', err);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      sendMessage();
    }
  };

  const toggleEmojiPanel = () => {
    setEmojiPanelVisible((prev) => !prev);
  };

  const handleEmojiSelect = (emoji) => {
    setInput((prev) => prev + emoji.native);
    inputRef.current?.focus();
  };

  const hideEmojiPanel = () => {
    setEmojiPanelVisible(false);
  };

  return (
      <div className="flex items-center bg-white rounded-full px-4 py-2 shadow-sm gap-3 relative">
        {/* Кнопка эмодзи + панель */}
        <div className="relative">
          <div
              className={`absolute bottom-full z-50 ${emojiPanelVisible ? '' : 'hidden'}`}
              onMouseLeave={hideEmojiPanel}
          >
            <Picker
                data={data}
                onEmojiSelect={handleEmojiSelect}
                emojiSize={18}
                emojiButtonSize={28}
                theme="light"
                emojiStyle="apple"
                previewPosition="none"
            />
          </div>
          <button onClick={toggleEmojiPanel} type="button">
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path
                  fill="#9B9BAA"
                  d="M12 2C17.5228 2 22 6.47715 22 12s-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2Zm0 1.5C7.3056 3.5 3.5 7.3056 3.5 12S7.3056 20.5 12 20.5 20.5 16.6944 20.5 12 16.6944 3.5 12 3.5Zm-3 6a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 9 9.5Zm6 0a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 15 9.5Zm-6.295 6.14a.5.5 0 1 1 .79-.61 4.5 4.5 0 0 0 6.01 0 .5.5 0 1 1 .79.61 5.5 5.5 0 0 1-7.59 0Z"
              />
            </svg>
          </button>
        </div>

        {/* Поле ввода */}
        <input
            ref={inputRef}
            className="w-full text-sm placeholder:text-[#C4B2F8] text-[#363645] outline-none"
            placeholder="Введите сообщение..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyPress}
        />

        {/* Кнопка отправки */}
        <button onClick={sendMessage} disabled={isSending}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M2.649 19.386C1.151 20.12 -0.503 18.688 0.184 17.251L3.657 10.001 0.184 2.753C-0.505 1.315 1.151 -0.118 2.649 0.617L18.774 8.539C19.06 8.68 19.3 8.891 19.467 9.149C19.634 9.406 19.723 9.701 19.723 10.002C19.723 10.303 19.634 10.598 19.467 10.856C19.3 11.113 19.06 11.324 18.774 11.465L2.649 19.386Z"
                fill="#6446C3"
            />
          </svg>
        </button>
      </div>
  );
};

export default ChatMessageLine;
